import { Box, Icon, Spinner } from '@chakra-ui/react'
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons'
import { SortDirection, SortField } from '../utils/sortUtils'

interface SortIconProps {
  /** Whether this column is actively being sorted */
  active: boolean
  /** Current sort direction (asc or desc) */
  direction: SortDirection
  /** Whether a sort operation is in progress */
  isSorting: boolean
  /** Field this icon represents */
  field: SortField
}

/**
 * Displays the appropriate sort icon based on state
 * - Spinner when sorting is in progress
 * - Up/down arrow when column is actively sorted
 * - Both arrows in light gray when column is not being sorted
 */
const SortIcon = ({ active, direction, isSorting, field }: SortIconProps) => {
  // When sorting is in progress, show spinner
  if (isSorting) {
    return (
      <Spinner
        ml={1}
        size="xs"
        color="blue.500"
        thickness="2px"
      />
    )
  }
  
  // When active, show only the relevant arrow
  if (active) {
    return (
      <Icon
        as={direction === 'asc' ? TriangleDownIcon : TriangleUpIcon}
        ml={1}
        w={3}
        h={3}
        color="blue.500"
      />
    )
  }
  
  // When not active, show both arrows in lighter color
  return (
    <Box position="relative" ml={1} h={3} w={3}>
      <Icon
        as={TriangleUpIcon}
        position="absolute"
        top="-3px"
        left="0"
        w={3}
        h={3}
        color="gray.400"
      />
      <Icon
        as={TriangleDownIcon}
        position="absolute"
        bottom="-3px"
        left="0"
        w={3}
        h={3}
        color="gray.400"
      />
    </Box>
  )
}

export default SortIcon